import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/sixsense-website-v2/sixsense-website-v2/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/sixsense-website-v2/sixsense-website-v2/src/app/blog/BlogList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/sixsense-website-v2/sixsense-website-v2/src/components/ui/Slider.tsx");
